/** Background colors for HDM fiscal departments on POS category tabs. */
const DEPT_COLORS = {
    1: '#6b7280',
    2: '#059669',
    3: '#2563eb',
    4: '#d97706',
    5: '#7c3aed',
    6: '#db2777',
};
const FALLBACK_COLORS = ['#64748b', '#0d9488', '#4f46e5', '#ca8a04', '#9333ea', '#e11d48'];
export function departmentColor(departmentId) {
    return DEPT_COLORS[departmentId] ?? FALLBACK_COLORS[(departmentId - 1) % FALLBACK_COLORS.length];
}
function mixWithWhite(hex, whiteRatio) {
    const h = hex.replace('#', '');
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    const mix = (c) => Math.round(c + (255 - c) * whiteRatio);
    return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
}
/** Inline styles for a POS category tab tinted by fiscal department. */
export function departmentTabStyle(departmentId, options = {}) {
    const base = departmentColor(departmentId);
    if (options.disabled) {
        return {
            background: mixWithWhite(base, 0.55),
            borderColor: mixWithWhite(base, 0.4),
            color: base,
            opacity: 0.45,
        };
    }
    if (options.active) {
        return {
            background: base,
            borderColor: base,
            color: '#fff',
            fontWeight: 600,
        };
    }
    return {
        background: mixWithWhite(base, 0.78),
        borderColor: mixWithWhite(base, 0.55),
        color: base,
    };
}
//# sourceMappingURL=departmentColors.js.map